import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { useGetCartDeliveriesQuery } from 'containers/Cart/rtkApi'
import DeliveryBox from './DeliveryBox'

import messages from '../messages'

const Deliveries = () => {
  const { formatMessage } = useIntl()

  const { data: cartDeliveries = {}, isLoading } = useGetCartDeliveriesQuery()
  const { deliveries = [] } = cartDeliveries

  const activeDeliveries = useMemo(
    () => deliveries.filter(({ isActive }) => isActive),
    [deliveries],
  )

  if (isLoading) return null

  return (
    <div className="flex flex-col w-full gap-[50px]">
      <div className="px-3 pt-5 lg:p-0">
        <h1 className="text-h1 text-grey-700">
          {formatMessage(messages.deliveriesCount, {
            count: activeDeliveries.length,
            styledText: text => <span className="text-blue-900">{text}</span>,
          })}
        </h1>
      </div>
      {/* TODO: switch to all deliveries when implementing incomings */}
      <div className="flex flex-col gap-[84px] lg:gap-[90px]">
        {activeDeliveries.map(delivery => (
          <DeliveryBox key={delivery.id} delivery={delivery} />
        ))}
      </div>
    </div>
  )
}

export default Deliveries
